import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminOrganizationsOrganizationRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ organization_id }) {
    const { content } = await this.store.request(
      findRecord('organization', organization_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
